import type { Widget } from './Widget';

export const getHtml = ({ widget: { __sswi__iframe } }: { widget: Widget }) => __sswi__iframe;
